import React, { useEffect, useState } from 'react';
import ListItem from './ListItem';

const TotalList = ({ total, pageAuthor, currentUser }) => {
const [lowestOrder, setLowestOrder] = useState(0)

  useEffect(() => {
    const orderValues = [];
    total.forEach(item => {
      if (item.isPrivate === 0 || pageAuthor === currentUser) {
        orderValues.push(item.order)
      }
    })
    setLowestOrder(Math.min(...orderValues))
  }, [total, currentUser, pageAuthor])

  return (
    <div>
      {total.map((item, index) => (
        <ListItem key={index} item={item} lowestOrder={lowestOrder} pageAuthor={pageAuthor} currentUser={currentUser}/>
      ))}
    </div>
  );
};

export default TotalList;